import { AgendaMagasin } from '@components/agenda-magasin/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const agendaMagasinMock: Block<AgendaMagasin> = {
  type: 'agenda-magasin',
  data: {
    title: {
      text: `Je prends [[rendez-vous]]`,
      as: 'span',
    },
    image: imageMock,
    store: {
      name: `Socoo'c Rennes`,
      uuid: `socooc-rennes`,
      phone: '0299909010',
      streetName: '14 rue de la cuisine',
      zipcode: '35000',
      city: 'Rennes',
      isVisioAppointmentAvailable: true,
    },
    gtmConfigCallBtn: {
      event: 'click_cta_appel_magasin',
      group: 'appel',
      description: 'bloc rdv magasin {{nom du magasin}}',
      context: 'clic pour appeler',
    },
  },
};
